import React from 'react';

const LilysDeckPage = () => {
  return (
    <iframe
      src="/lilys/index.html"
      title="Lily's Silver Spoon — Case Study"
      style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
    />
  );
};

export default LilysDeckPage;
